import generateHTML from "./generateHTML";
import createSlider from "./createSlider";
import initialiseSlider from "./initialiseSlider";

const implementSlider = topPicksInfo => {    
    const generatedHTML = generateHTML(topPicksInfo);
    createSlider(generatedHTML);      
    initialiseSlider();
}

export default implementSlider;